import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/privacy-policy/hero";
import PP from "../components/privacy-policy/content";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Same Day Smile Ilkley | Your Data Safety</title>
        <meta
          name="description"
          content="Explore how Same Day Smile Ilkley protects your personal data. We are dedicated to maintaining your privacy with transparent policies and secure information handling."
        />
        <link
          rel="canonical"
          href="https://www.samedaysmile-ilkley.com/privacy-policy"
        />
      </Helmet>
      <Navbar />
      <Header />
      <PP />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
